import {
  Maybe,
  PerformanceAssessmentAnswerFilter,
  TalentIndicatorType,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { CareerTrackPickerTrack } from "@apps/org-settings/components/competencies/career-track-picker";
import { CareerTrackRolePickerRole } from "@apps/org-settings/components/competencies/career-track-role-picker";

import { TeamPickerTeam } from "../../team-picker";

export enum AssessmentReportSortType {
  KEY,
  QUESTION_ID,
  ROLE_AVG,
  SELF_ROLE_AVG,
}
export enum AssessmentReportSortKey {
  NAME,
  ASSESSMENT_STATUS,
  CALIBRATION_STATUS,
  DELIVERY_STATUS,
  CAREER_TRACK,
  ROLE,
  CAREER_LEVEL,
  MANAGER,
  POSITION,
  TEAM,
  ENROLLMENT_DATE,
}
export type AssessmentReportSort =
  | {
      type: AssessmentReportSortType.KEY;
      key: AssessmentReportSortKey;
    }
  | {
      type: AssessmentReportSortType.QUESTION_ID;
      questionId: number;
    }
  | {
      type: AssessmentReportSortType.ROLE_AVG;
    }
  | {
      type: AssessmentReportSortType.SELF_ROLE_AVG;
    };

export enum AssessmentReportFilterMatchType {
  MATCH_ALL = "match_all",
  MATCH_ANY = "match_any",
}

export type AssessmentReportViewOptions = {
  id?: number | null;
  isDirty: boolean;
  name: string;
  filters: {
    type: AssessmentReportFilterMatchType;
    list: AssessmentReportFilterItem[];
  };
  tableColumns: {
    id: string | number;
    hidden: boolean;
  }[];
  hiddenRecentAnswers?: number[];
  nineBox: {
    selectedXQuestionIndex: number;
    selectedYQuestionIndex: number | null;
  };
};

export type AssessmentReportTableColumn = {
  id: string | number;
  label: string;
  columnSortKey: AssessmentReportSort;
  questionLabels?: Maybe<string>[];
};

export enum AssessmentReportFilterType {
  TEAM = "team",
  ROLE = "role",
  CAREER_TRACK = "careerTrack",
  CAREER_TRACK_LEVEL = "careerTrackLevel",
  USER = "user",
  REPORTS_TO = "reportsTo",
  ANSWER = "answer",
  TALENT_INDICATOR = "talentIndicator",
  ENROLLMENT_DATE = "enrollmentDate",
}

export type AssessmentReportFilterItemOptions = {
  talentIndicator?: {
    type: TalentIndicatorType;
    questionId: number;
    questionLabels: string[];
    startValue: number;
    label: string;
  };
};

export type AssessmentReportFilterItem =
  | {
      type: AssessmentReportFilterType.ENROLLMENT_DATE;
      data: (string | null)[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.TEAM;
      data: TeamPickerTeam[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.ROLE;
      data: CareerTrackRolePickerRole[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.CAREER_TRACK;
      data: CareerTrackPickerTrack[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.CAREER_TRACK_LEVEL;
      data: number[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.USER;
      data: BasicUser[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.REPORTS_TO;
      data: BasicUser[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.ANSWER;
      data: PerformanceAssessmentAnswerFilter[];
      options: AssessmentReportFilterItemOptions;
    }
  | {
      type: AssessmentReportFilterType.TALENT_INDICATOR;
      data: PerformanceAssessmentAnswerFilter[];
      options: AssessmentReportFilterItemOptions;
    };
